import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, mergeMap, take } from 'rxjs/operators';

import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { ProductsService } from '@shared/services/products.service';
import { ProductSkuFilterRequest } from '@shared/models/request/product-sku-filter-request';

@Injectable({
  providedIn: 'root'
})
export class ProductListResolver implements Resolve<any>{

  constructor(private router: Router, private productService: ProductsService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let filter = new ProductSkuFilterRequest()
    let page = 0
    let sortBy = "displayOrder,id"
    let order = "DESC"
    filter.categoryIds.push(route.params.categoryId)
    //Add is sale param
    filter.isSale = route.queryParamMap.get("isSale")

    //Check url params
    if(route.queryParamMap.keys.length > 1) {
      page = parseInt(route.queryParamMap.get("page"))
      sortBy = route.queryParamMap.get("sortBy")
      order = route.queryParamMap.get("order")
      const colors = route.queryParamMap.getAll("colors").map(color => {
        return {
          attribute: "filterColor",
          value: color
        }
      })
      const sizes = route.queryParamMap.getAll("sizes").map(size => {
        return {
          attribute: "displaySize",
          value: size
        }
      })
      const categoryIds = route.queryParamMap.getAll("categoryIds").map(id => parseInt(id))
      filter.attributes = colors.concat(sizes)
      filter.categoryIds = categoryIds
    }
    return this.productService.getProductList(page, sortBy, "12", order, filter).pipe(
      take(1),
      map(res => {
        if (res) {
          return res;
        } else {
          this.router.navigate(['/home']);
          return null;
        }
      })
    )
  }

}
